import Cookies from 'js-cookie'
import data from 'backend-data/index.js.erb'
import themeSettings from 'embed/themeSettings'
import shopifyData from 'embed/shopifyData'
import Bugsnag from '@bugsnag/js';
import ReactGA from "react-ga4";

export const notifyBugsnag = (error) => {
  if (!navigator.userAgent.match(/(bot|Bot)/i)) {
    Bugsnag.start({
      appVersion: '1.0.0',
      apiKey: '732b7e4b1decdc06ae6151f9dad7e33f',
      autoNotify: false,
      autoDetectErrors: false,
      notifyReleaseStages: ['production', 'staging']
    })
    Bugsnag.notify(error)
  }
}

export const mfToken = () => {
  if (navigator.cookieEnabled) {
    const cookieName = `${data.environment}_mf_tkn`
    let mfTkn = Cookies.get(cookieName)
    if (mfTkn) {
      return mfTkn
    }
    mfTkn = getMfTokenFromScript()
    Cookies.set(cookieName, mfTkn, { expires: 7 });
    return mfTkn;
  } else {
    return getMfTokenFromScript();
  }
}

const getMfTokenFromScript = () => {
  let mfTkn;
  let scripts = document.getElementsByTagName('script');
  for (let s, i = scripts.length; i && (s = scripts[--i]);) {
    s = s.getAttribute('src') || s.getAttribute('data-src');
    if (s && (typeof s === 'string') && (s = s.match(/^(.*)\/packs\/(mf_embed_v|mf_embed_woocommerce_v)\d.js\?(\w*)=([^&]*)/))) {
      mfTkn = s[4];
      break;
    }
  }
  if (mfTkn == undefined && typeof Shopify != "undefined") {
    mfTkn = Shopify.shop
  }
  return mfTkn
}

export const showPopup = (type = 'show_mf_modal') => {
  if (!makeAnOfferData.iframeLoaded) {
    setTimeout(() => {
      showPopup();
    }, 1000);
    return
  }
  const iframeWrapper = document.getElementById('iframe-div')
  iframeWrapper.style.visibility = 'visible'
  iframeWrapper.style.display = 'block'
  let content = document.getElementById('mfIframe').contentWindow
  content.focus();
  const previousOffer = getPreviousOffer();
  if (isProductPage() && previousOffer) {
    content.postMessage({ type: 'show_previous_result', offer: previousOffer, combine: false }, '*');
  } else {
    content.postMessage({ type, combine: false }, '*');
  }
  var quantity = document.querySelector('[name="quantity"]');
  quantity = quantity ? quantity.value : 1
  const iframe = window.frames["mfIframe"]
  let  product_attributes;
  makeAnOfferData.product ? (
    product_attributes = {type: 'product_attributes' , tags: makeAnOfferData.product.tags, collections: makeAnOfferData.product.collections, quantity: quantity}
    ) : (
    product_attributes = {type: 'product_attributes' , tags: makeAnOfferData.cartProducts[0].tags, collections: makeAnOfferData.cartProducts[0].collections}
    )
    iframe.contentWindow.postMessage(product_attributes, "*");
}

const getPreviousOffer = () => {
  let offers = Cookies.get('mf_offers')
  if (offers) {
    offers = JSON.parse(offers)
    return offers.find(offer => {
      return MFBase.getProducts().find(product => {
        return product.variant == offer.product.variant;
      })
    })
  }
}

export const isProductPage = (data = null) => {
  if (data && data.one_page_shop) {
    return true
  } else if (isWoocommercePlatform()) {
    return window.location.pathname.indexOf('/product') >= 0
  } else if (isBigcommercePlatform()) {
    const url = makeAnOfferData.product.url
    return url.length && window.location.href.indexOf(url) >= 0
  } else {
    return window.location.pathname.indexOf('/products') >= 0
  }
}

export const isCartPage = () => {
  return window.location.pathname.indexOf('/cart') >= 0
}

export const isMobile = () => {
  if (navigator.userAgent.match(/Android/i)
    || navigator.userAgent.match(/webOS/i)
    || navigator.userAgent.match(/iPhone/i)
    || navigator.userAgent.match(/iPad/i)
    || navigator.userAgent.match(/iPod/i)
    || navigator.userAgent.match(/BlackBerry/i)
    || navigator.userAgent.match(/Windows Phone/i)
  ) {
    return true;
  }
  else {
    return false;
  }
}

export const initializeProductForm = (data) => {
  const productFormClass = 'mf_product_form'
  let form = document.getElementsByClassName(productFormClass)[0]
  if (form) {
    return form
  } else if (isBigcommercePlatform()) {
    if (!form) {
      form = document.querySelector('form[data-cart-item-add]');
      if (form) form.classList.add(productFormClass);
      return form
    }
  } else if (isWoocommercePlatform()) {
    let form = document.getElementsByClassName('cart')[0]
    if (form) form.classList.add(productFormClass);
    return form
  } else {
    let variants = ((data.product && data.product.variants) || []).map(v => v.id);
    // Loop through variant ids and find the first element with value=id
    for (let i = 0; i < variants.length; i++) {
      let vid = variants[i];
      // get all inputs of vid
      let variantIdInputs = document.querySelectorAll(`form[action*="/cart/add"] [value="${vid}"]`);
      let maoInput = document.querySelectorAll(`form[action*="/cart/add"] [data-mao-form="true"]`);
      console.log("variantIdInputs", variantIdInputs)
      console.log("maoInput", maoInput)
      if (maoInput && maoInput.length > 0) {
        variantIdInputs = maoInput;
        console.log("maoInput..........if condition", variantIdInputs)
      }
      // To Get Variant DIV Element for Shopify Xtra Theme
      variantIdInputs = variantIdInputs.length > 0 ? variantIdInputs : document.querySelectorAll(`form[action*="/cart/add"] [data-value="${vid}"]`);
      let variantIdInput = variantIdInputs[variantIdInputs.length - 1];
      console.log("variantIdInput..", variantIdInput)
      console.log(variantIdInputs.length > 0 ? "already variant maoInput" : "querySelector")
      // If there is no matched add button in cart forms, just use the last cart
      // form match. This would match the correct cart form in the original Dawn
      // theme, and the only cart form in the pre-Dawn theme.
      for (let x = 0; x < variantIdInputs.length; x++) {
        let addToCartButtons = variantIdInputs[x].closest('form').querySelectorAll("button:not([name]), button[name=add], input[type=submit]:not([name]), input[type=submit][name=add]");
        if (addToCartButtons.length > 0) {
          variantIdInput = variantIdInputs[x];
        }
      }
      console.log("outconditon.......variantIdInput", variantIdInput)
      if (variantIdInput) {
        form = variantIdInput.closest('form')
        console.log("add..fomr", form)
        if (form) form.classList.add(productFormClass);
        break;
      }
    }
    if (!form) {
      if (data.product) {
        notifyBugsnag("MF: Product page but no product form detected")
      }

      console.log("MF: No product form detected in this page.")
    }
    return form
  }
}

export const isShopifyPlatform = () => {
  return makeAnOfferData.platform == 'shopify'
}

export const isWoocommercePlatform = () => {
  return makeAnOfferData.platform == 'woocommerce'
}

export const isBigcommercePlatform = () => {
  return makeAnOfferData.platform == 'bigcommerce'
}

export const serializeArray = (form) => {
  var field, l, s = [];
  if (typeof form == 'object' && form.nodeName == "FORM") {
    var len = form.elements.length;
    for (var i = 0; i < len; i++) {
      field = form.elements[i];
      if (field.name && !field.disabled && field.type != 'file' && field.type != 'reset' && field.type != 'submit' && field.type != 'button') {
        if (field.type == 'select-multiple') {
          l = form.elements[i].options.length;
          for (j = 0; j < l; j++) {
            if (field.options[j].selected)
              s[s.length] = { name: field.name, value: field.options[j].value };
          }
        } else if ((field.type != 'checkbox' && field.type != 'radio') || field.checked) {
          s[s.length] = { name: field.name, value: field.value };
        }
      }
    }
  }
  return s;
}

export const detectIEEdge = () => {
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}

export const httpGetAsync = (theUrl, callback, store) => {
  var xmlHttp = new XMLHttpRequest();
  xmlHttp.onreadystatechange = function () {
    if (xmlHttp.readyState == 4 && xmlHttp.status == 200) {
      callback(xmlHttp.responseText, store);
    }
  }
  xmlHttp.open("GET", theUrl, true); // true for asynchronous
  xmlHttp.send(null);
}

export const getAddToCartButton = (form) => {
  if (form) {
    let addToCartButton = form.querySelector("[type='submit']");
    if (!addToCartButton) {
      let items = form.getElementsByTagName('button')
      for (var item of items) {
        if (item.className.match(/cart/i)) {
          addToCartButton = item
        }
      }
    }
    return addToCartButton
  }
}

export const getButtonContainer = (settings, form) => {
  let container = document.getElementById('mf_button');
  if (!settings.automatic_button_style) {
    return container || form
  }

  if (form) {
    const addToCartButton = getAddToCartButton(form);

    let mfContainer = document.getElementById('mf_container');
    if (!mfContainer && addToCartButton && settings.automatic_button_style) {
      mfContainer = document.createElement('div');
      mfContainer.setAttribute("id", "mf_container");
      const themeContainer = getThemeContainer();

      if (themeContainer) {
        themeContainer.parentNode.insertBefore(mfContainer, themeContainer.nextSibling);
      } else {
        const addToCartButtonStyle = addToCartButton.currentStyle || window.getComputedStyle(addToCartButton);
        let marginBottom = addToCartButtonStyle.marginBottom;
        let marginTop = addToCartButtonStyle.marginTop;
        if (marginBottom == '0px' && marginTop == '0px') {
          addToCartButton.style.marginBottom = "10px";
        }
        addToCartButton.parentNode.insertBefore(mfContainer, addToCartButton.nextSibling);
      }
      addStylesForElement(mfContainer, 'container');
    }
    if (isBigcommercePlatform() && mfContainer) {
      mfContainer.style.display = 'inline';
    }
    container = mfContainer;
  }
  return container || form
}

export const getCartPageNoticeContainer = () => {
  var customWrapper = document.getElementById("#mf_cart_page_notice_wrapper");
  var cartHeader = document.getElementsByClassName("cart-header")[0];
  var cartTable = document.getElementsByClassName("cart")[0];
  var body = document.getElementsByTagName("body")[0];

  if (!!customWrapper) {
    return customWrapper;
  } else if (!!cartHeader) {
    return cartHeader;
  } else if (!!cartTable) {
    return cartTable;
  } else {
    return body;
  }
}

export const addStylesForElement = (el, name) => {
  const settings = getDefaultThemeSettings();
  if (el && settings ) {
    const mobileSettings = settings.mobile
    if (mobileSettings && isMobile()) {
      if (mobileSettings[name]) {
        for (let attr in mobileSettings[name]) {
          el.style[attr] = mobileSettings[name][attr];
        }
      }
    } else {
      if (settings[name]) {
        for (let attr in settings[name]) {
          el.style[attr] = settings[name][attr];
        }
      }
    }
  }
}

const getThemeContainer = () => {
  const settings = getDefaultThemeSettings();
  console.log(settings)
  if (settings) {
    if (settings['positionBlock']) {
      return document.querySelector(settings['positionBlock']);
    }
  }
}

const getDefaultThemeSettings = () => {
  if (typeof Shopify !== 'undefined' && Shopify.theme) {
    let currentThemeName = Shopify.theme.name.toLowerCase();
    let themeName = Object.keys(themeSettings).find((name) => currentThemeName.includes(name))
    if (themeName) {
      return themeSettings[themeName]
    }
  }
}

export const getCurencyISO = () => {
  if (typeof Shopify !== 'undefined' && Shopify.currency) {
    return Shopify.currency.active
  }
  return null;
}

export const getCurencyRate = () => {
  if (typeof Shopify !== 'undefined' && Shopify.currency) {
    return Shopify.currency.rate;
  }
  return null;
}

export const tractGA4Events = (trackData) => {
  const { category, action, label, trackingId, analyticsActive } = trackData
  if(analyticsActive === 'true' && trackingId != "") {
    ReactGA.initialize(trackingId);
    ReactGA.event({
      category: category, 
      action: action,
      label: label,
    })
  }
}
